import { transition, trigger, useAnimation } from '@angular/animations'
import { Component, computed, inject, input } from '@angular/core'
import { ProductKey } from '@naturalcycles/shared'
import { MixpanelService } from '@src/app/core/services/analytics/mixpanel.service.js'
import { fadeAnimation, staggerAnimation } from '@src/app/core/util/animations.util.js'
import { MixpanelEvent } from '@src/app/shared/typings/analytics.js'

@Component({
  selector: 'do-you-own-device',
  templateUrl: './do-you-own-device.component.html',
  styleUrls: ['./do-you-own-device.component.scss'],
  animations: [
    trigger('fadeAnimation', [transition('* => *', [useAnimation(fadeAnimation)])]),
    trigger('staggerAnimation', [transition('* => *', [useAnimation(staggerAnimation)])]),
  ],
  standalone: false,
})
export class DoYouOwnDeviceComponent {
  protected device = computed(() => this.api().measuringDevice)

  protected api = input.required<{
    measuringDevice: ProductKey.APPLE_WATCH | ProductKey.OURA_RING_DISCOUNT
    select: (b: boolean) => Promise<boolean>
  }>()

  private mixpanelService = inject(MixpanelService)

  async onSelect(ownsDevice: boolean): Promise<boolean> {
    // For now we will keep sending the same mixpanel event for Oura users
    // before we move over to using programmatically created events
    if (this.api().measuringDevice === ProductKey.OURA_RING_DISCOUNT) {
      void this.mixpanelService.trackEvent(MixpanelEvent.HasOuraRing, { ownsOura: ownsDevice })
    }

    void this.mixpanelService.trackEvent(`owns${this.api().measuringDevice}`, {
      [`owns${this.api().measuringDevice}`]: ownsDevice,
    })

    return await this.api().select(ownsDevice)
  }
}
